import { pluralize } from "@inrev/common";
import {
	type ExperianCreditDetail,
	formatReportDate,
	inquiriesWithinMonths,
} from "@portal/api/account/admin/individualCreditReport";
import { DynamicDataTable } from "@portal/components/ui/DynamicDataTable/DynamicDataTable";
import type { DynamicDataTableColumn } from "@portal/components/ui/DynamicDataTable/types";
import { DateTime } from "luxon";
import type { FC } from "react";
import { formatEmpty } from "../../../../../../../utils";
import { ReportSection, SectionSummary } from "./ReportSection";

type Detail = ExperianCreditDetail;
type Inquiry = Detail["inquiries"][number];

const columns: DynamicDataTableColumn<Inquiry>[] = [
	{
		id: "date",
		accessorKey: "date",
		header: "Date",
		size: 140,
		enableSorting: true,
		cell: ({ row }) => formatReportDate(row.original.date),
	},
	{
		id: "inquirer",
		accessorKey: "inquirer",
		header: "Inquirer",
		size: 360,
		enableSorting: true,
	},
	{
		id: "creditType",
		accessorKey: "creditType",
		header: "Credit type",
		size: 240,
		cell: ({ row }) => formatEmpty(row.original.creditType),
	},
];

export const InquiriesSection: FC<{ detail: Detail; pulledAt: string }> = ({
	detail,
	pulledAt,
}) => {
	const recent = inquiriesWithinMonths(detail.inquiries, 12, DateTime.fromISO(pulledAt));
	return (
		<ReportSection
			title="Hard Inquiries"
			testId="individual_credit_inquiries"
			summary={
				<SectionSummary>{pluralize(recent, "inquiry", "inquiries")} in 12 months</SectionSummary>
			}
		>
			<DynamicDataTable
				name="individual_credit_report_inquiries"
				columns={columns}
				data={detail.inquiries}
				expandToContent
			/>
		</ReportSection>
	);
};
